import axiosClient from 'utils/axiosClient';
import api from 'api';

const getPackages = async (data: any) => {
	const response = await axiosClient.get(api.LIBRARY.PACKAGES.PACKAGES, {params: data});
	return response.data;
};
const getPackageByID = async (id: any) => {
	const response = await axiosClient.get(api.LIBRARY.PACKAGES.PACKAGES_BY_ID + id);
	return response.data;
};

const createPackage = async (data: any) => {
	const response = await axiosClient.post(api.LIBRARY.PACKAGES.PACKAGES, data);
	return response.data;
};

const updatePackage = async (id: any, data: number) => {
	const response = await axiosClient.patch(api.LIBRARY.PACKAGES.PACKAGES_BY_ID + id, data);
	return response.data;
};

const deletePackages = async (id: number) => {
	const response = await axiosClient.delete(api.LIBRARY.PACKAGES.PACKAGES_BY_IDS + id);
	return response.data;
};

const addBooksIntoPackage = async (id: number, bookIDs: number[]) => {
	const response = await axiosClient.post(api.LIBRARY.PACKAGES.PACKAGE_ITEMS_BY_ID + id + '/items', {
		bookIDs
	});
	return response.data;
};

const deleteBooksFromPackage = async (id: number, booksIDs: any) => {
	const response = await axiosClient.delete(
		api.LIBRARY.PACKAGES.PACKAGE_ITEMS_BY_ID + id + '/items/' + booksIDs
	);
	return response.data;
};

const issuePackageBooks = async (data: any) => {
	const response = await axiosClient.post(api.LIBRARY.PACKAGES.ISSUE_PACKAGE_BOOKS, data);
	return response.data;
};
const getPackageBooks = async (packageID: any, data: any) => {
	const response = await axiosClient.get(api.LIBRARY.PACKAGES.PACKAGES_BY_ID + `${packageID}/books`, {
		params: data
	});
	return response.data;
};

const service = {
	getPackages,
	getPackageByID,
	createPackage,
	updatePackage,
	deletePackages,
	addBooksIntoPackage,
	deleteBooksFromPackage,
	issuePackageBooks,
	getPackageBooks
};

export default service;
